import React from 'react';

import { Button } from '../Buttons';
import { InlineAlert } from '../InlineAlert';

export interface ChangeTargetProps {
  readonly label: string;
  readonly describedBy: string;
  readonly held: boolean;
  readonly autoFocus?: boolean;
  readonly onChangeTarget: () => void;
}

export const ChangeTarget: React.FC<ChangeTargetProps> = ({ label, describedBy, held, autoFocus = false, onChangeTarget }) => (
  <Button
    type="button"
    intent="tertiary"
    autoFocus={autoFocus}
    aria-describedby={describedBy}
    aria-disabled={held || undefined}
    onClick={onChangeTarget}
  >
    {label}
  </Button>
);

export const SendError: React.FC<{ message: string | null }> = ({ message }) =>
  message === null ? null : <InlineAlert severity="error" role="alert" message={message} />;
